// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ScatterplotIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ScatterplotIcon" ref={forwardedRef} {...props}>
      <path d="M3 3h1.5v12.5H17V17H4a1 1 0 0 1-1-1z" />
      <path d="M11 5.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0" />
      <path d="M7.125 13.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25" />
      <path d="M11 9.5a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0" />
      <path d="M13.875 5.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25" />
      <path d="M13 12.69a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0" />
      <path d="M13.875 9.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ScatterplotIcon = /* @__PURE__ */ Object.assign(
  ScatterplotIconComponent,
  { displayName: 'ScatterplotIcon' },
);
